<!--simple-notifications [options]="{}"></simple-notifications-->
<style>
  html, body {
    width: 100%;
    height: 100%;
  }
</style>

@if (isLoggedIn) {
  <div class="app" [ngxInactivity]="inactivity" (ngxInactivityCallback)="handleFirstInactivityCallback()"></div>
}
<script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.1.3/Chart.bundle.min.js"
        integrity="sha512-kbRra9Hyf4zu24n7OhipCAWLZEptnBZpDqQhHQQzTeDrVyqiJQa0bVR/fuL5qbq4xNIJIcdSC30QH+PF8tx9mw=="
        crossorigin="anonymous" referrerpolicy="no-referrer"></script>

<div style="position: relative; height: 80px;width: 100%;" [style.backgroundColor]="settings?.bannerColor || '#ffffff'" *ngIf="isHeaderActive()">
  <img style="margin: 10px 10px 10px 40px; height: 60px;" [src]="clientLogo" alt="clientLogo" *ngIf="clientLogo" />

  <img style="right: 60px; top: 10px; height: 60px; position:absolute;" alt="consultantLogo" [src]="consultantLogo"
       *ngIf="consultantLogo" />
</div>

<div style="display: flex; flex-direction: row;">
  <div style="flex:0 0 auto" *ngIf="isHeaderActive()">
    <app-header></app-header>
  </div>
  <div style="flex:1 1 auto; overflow: auto;" [ngStyle]="{height: isHeaderActive() ? 'calc(100vh - 165px)' : '100vh'}">
<!--alert [hidden]="alertService.suppressRootAlert | async"></alert-->
    <router-outlet></router-outlet>
  </div>
</div>
<div class="loading" *ngIf="alertService.loadingValue">
  <svg width="80px" height="80px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
       xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"
       x="0px" y="0px">
    <g id="outer">
        <g>
            <path d="M20,0C22.2058,0 23.9939,1.78813 23.9939,3.9939C23.9939,6.19968 22.2058,7.98781 20,7.98781C17.7942,7.98781 16.0061,6.19968 16.0061,3.9939C16.0061,1.78813 17.7942,0 20,0Z" style="fill:rgba(255,165,0,1);"/>
        </g>
      <g>
            <path d="M5.85786,5.85786C7.41758,4.29815 9.94638,4.29815 11.5061,5.85786C13.0658,7.41758 13.0658,9.94638 11.5061,11.5061C9.94638,13.0658 7.41758,13.0658 5.85786,11.5061C4.29815,9.94638 4.29815,7.41758 5.85786,5.85786Z" style="fill:rgba(255,165,0,0.3);"/>
        </g>
      <g>
            <path d="M20,32.0122C22.2058,32.0122 23.9939,33.8003 23.9939,36.0061C23.9939,38.2119 22.2058,40 20,40C17.7942,40 16.0061,38.2119 16.0061,36.0061C16.0061,33.8003 17.7942,32.0122 20,32.0122Z" style="fill:rgba(255,165,0,0.6);"/>
        </g>
      <g>
            <path d="M28.4939,28.4939C30.0536,26.9342 32.5824,26.9342 34.1421,28.4939C35.7019,30.0536 35.7019,32.5824 34.1421,34.1421C32.5824,35.7019 30.0536,35.7019 28.4939,34.1421C26.9342,32.5824 26.9342,30.0536 28.4939,28.4939Z" style="fill:rgba(255,165,0,0.7);"/>
        </g>
      <g>
            <path d="M3.9939,16.0061C6.19968,16.0061 7.98781,17.7942 7.98781,20C7.98781,22.2058 6.19968,23.9939 3.9939,23.9939C1.78813,23.9939 0,22.2058 0,20C0,17.7942 1.78813,16.0061 3.9939,16.0061Z" style="fill:rgba(255,165,0,0.4);"/>
        </g>
      <g>
            <path d="M5.85786,28.4939C7.41758,26.9342 9.94638,26.9342 11.5061,28.4939C13.0658,30.0536 13.0658,32.5824 11.5061,34.1421C9.94638,35.7019 7.41758,35.7019 5.85786,34.1421C4.29815,32.5824 4.29815,30.0536 5.85786,28.4939Z" style="fill:rgba(255,165,0,0.5);"/>
        </g>
      <g>
            <path d="M36.0061,16.0061C38.2119,16.0061 40,17.7942 40,20C40,22.2058 38.2119,23.9939 36.0061,23.9939C33.8003,23.9939 32.0122,22.2058 32.0122,20C32.0122,17.7942 33.8003,16.0061 36.0061,16.0061Z" style="fill:rgba(255,165,0,0.8);"/>
        </g>
      <g>
            <path d="M28.4939,5.85786C30.0536,4.29815 32.5824,4.29815 34.1421,5.85786C35.7019,7.41758 35.7019,9.94638 34.1421,11.5061C32.5824,13.0658 30.0536,13.0658 28.4939,11.5061C26.9342,9.94638 26.9342,7.41758 28.4939,5.85786Z" style="fill:rgba(255,165,0,0.9);"/>
        </g>
    </g>
</svg>
  <img width="28" src="../assets/img/Rizkly%20Icon.png"/>
</div>
<footer *ngIf="isHeaderActive()">
  <div class="powered-by">Powered by: <img src="../assets/img/logo_light1.png"/> Version 7.3.1</div>
  <div>{{masterSettings?.footer || '&copy; 2017-2026 Rizkly, Inc. All Rights Reserved'}}</div>
</footer>
<p-toast position="top-center"></p-toast>
